import React from "react";
import { MyAccount as CleengMyAccount } from "@cleeng/mediastore-sdk";
const customCancellationReasons = [];
const MyAccount = () => {
  return (
    <div>
      <h1>MyAccount</h1>
      <div id="UpperComponentMyAccount">
        <CleengMyAccount
          displayGracePeriodError
          customCancellationReasons={customCancellationReasons}
        />
      </div>
    </div>
  );
};

export default MyAccount;
